var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "shape-arrow-forward-large",
  "use": "shape-arrow-forward-large-usage",
  "viewBox": "0 0 38 32",
  "content": "<symbol viewBox=\"0 0 38 32\" id=\"shape-arrow-forward-large\"><path d=\"M4 14h24.255l-6.971-6.971 2.13-2.115L34 15.5 23.414 26.086l-2.115-2.115L28.255 17H4v-3z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-sprite/shape-arrow-forward-large.svg
// module id = 178
// module chunks = 114276838955818 253700561180811